import { default as xhrRequest } from './xhrRequest.js';
import { default as streamRequest } from './streamRequest.js';
import { setOptions, getOptions } from './options.js';
const internal = {
    xhrRequest,
    streamRequest,
    setOptions,
    getOptions,
};
export { setOptions, getOptions, xhrRequest, internal, streamRequest };
